import script from "./AppointmentItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppointmentItem.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__